"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useTracking } from "react-tracking";
import { MarketingTypography } from "../../../MarketingTypography/index.js";
import { ContentContainer, IconContainer, TitleContainer } from "./styles.js";
const ItemIconTitle = forwardRef(
  ({
    activeTextBackgroundColor,
    activeTextColor,
    defaultTextBackgroundColor,
    defaultTextColor,
    hoverTextBackgroundColor,
    hoverTextColor,
    icons,
    titles,
    useActiveStyles,
    useHoverStyles
  }, ref) => {
    const { trackEvent } = useTracking();
    const onClick = () => {
      trackEvent({
        component: {
          identifier: "Accordion Set",
          trackedData: [titles[0]],
          type: "ui"
        },
        trackType: "navigation"
      });
    };
    return /* @__PURE__ */ jsxs(ContentContainer, { onClick, ref, children: [
      icons && /* @__PURE__ */ jsx(IconContainer, { children: useActiveStyles ? icons.activeIconColor : useHoverStyles ? icons.hoverIconColor : icons.defaultIconColor }),
      /* @__PURE__ */ jsx(TitleContainer, { children: titles.map((title) => {
        var _a;
        return /* @__PURE__ */ jsx(
          MarketingTypography,
          {
            color: useActiveStyles ? activeTextColor : useHoverStyles ? hoverTextColor : defaultTextColor,
            variant: title.select_text_type,
            isMarkdown: true,
            sx: {
              display: "block",
              backgroundColor: useActiveStyles ? activeTextBackgroundColor : useHoverStyles ? hoverTextBackgroundColor : defaultTextBackgroundColor
            },
            children: title.markdown_text
          },
          (_a = title._metadata) == null ? void 0 : _a.uid
        );
      }) })
    ] });
  }
);
ItemIconTitle.displayName = "ItemIconTitle";
export {
  ItemIconTitle
};
